import { Chip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function NeedsActionBadge({ canceled = false }: { canceled?: boolean }) {
  const theme = useTheme();

  const customStyle = {
    height: 20,
    fontSize: 8,
    fontWeight: 700,
    letterSpacing: 0.3,
    borderRadius: "4px",
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  };

  return (
    <Typography>
      <Chip component="span" label={canceled ? "CANCELED" : "NEEDS ACTION"} size="small" sx={customStyle} />
    </Typography>
  );
}
